import React, { useContext } from 'react';
import { AsyncPriceCourseCardContext } from '@udemy/browse-course';
import { AddToCart as AddToCartTempMigration } from '@udemy/cart-temp-migration';
import { BundleUnit } from '../bundle-unit/bundle-unit.react-component';
import { withSingleSelectableUnit } from '../single-selectable-unit/with-single-selectable-unit.react-component';

/** Note: This is the same implementation as packages/cart/src/add-to-cart/add-to-cart.react-component.tsx
 * to break the BundleUnit circular dependency
 **/
const InternalAddToCart = props => {
  const {
    isSingleSelectableUnit,
    bundleUnitStore,
    shouldRenderBundleUnit,
    ...addToCartProps
  } = props;
  const contextValue = useContext(AsyncPriceCourseCardContext);
  const renderBundleUnit = buyables => {
    if (shouldRenderBundleUnit && buyables !== null && buyables !== void 0 && buyables[0]) {
      return /*#__PURE__*/React.createElement(BundleUnit, {
        bundleUnitStore: bundleUnitStore,
        pageType: "cartSuccessModal",
        pageObjectId: buyables[0].id,
        titleTypography: "ud-heading-lg",
        forceGoToCart: true,
        allowAddToCartSuccessModal: false,
        isSingleSelectableUnit: isSingleSelectableUnit,
        useCourseProductCard: contextValue === null || contextValue === void 0 ? void 0 : contextValue.useCourseProductCard
      });
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(AddToCartTempMigration, Object.assign({
    renderBundleUnit: renderBundleUnit,
    isSingleSelectableUnit: isSingleSelectableUnit,
    uiRegion: props.uiRegion
  }, addToCartProps));
};
export const AddToCart = withSingleSelectableUnit(InternalAddToCart);
//# sourceMappingURL=add-to-cart.react-component.js.map